import { Blogo } from './blogo'

export const Blogos = () => {
  return (
    <div
      className="flex justify-between"
      style={{
        paddingTop: '1.5em',
      }}
    >
      <Blogo
        urlsp="https://www.teachersdiscovery.com/"
        alts="Teachers Discovery Logo"
        rurl="./redlogo.png"
        fw={150}
      />
      <Blogo
        urlsp="https://flangoo.com/"
        alts="Flangoo Logo"
        rurl="./FlangooLogo_2023.png"
        fw={200}
      />
    </div>
  )
}
